/**
 * RISKS-TOGGLE-ALL
 * Toggle button to open/close all risk families
 */

import { useState, useEffect } from "react"
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons"
import { useTranslation } from "react-i18next"
import ListButton from "@/components/list-button"
import { useAppSelector } from "@/core/root-reducer"
import riskStore from "../model/risk.store"
import { useRisksContext } from "../context/RisksContext"

export default function RisksToggleAll() {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const riskFamilies = useAppSelector(riskStore.selectors.listSelectedByUnits) as any[]
  const { setOpenFamilies, openFamilies } = useRisksContext()

  // Sync isOpen state with actual open families
  useEffect(() => {
    if (riskFamilies.length === 0) {
      setIsOpen(false)
    } else {
      const allOpen = riskFamilies.every((family) => openFamilies.includes(family.id))
      setIsOpen(allOpen)
    }
  }, [openFamilies, riskFamilies])

  function handleToggle() {
    const newState = !isOpen
    setIsOpen(newState)
    if (newState) {
      setOpenFamilies(riskFamilies.map((family) => family.id))
      // Scroll to first family when opening all
      if (riskFamilies.length > 0) {
        setTimeout(() => {
          document.getElementById(`family-${riskFamilies[0].id}`)?.scrollIntoView({ behavior: "smooth", block: "start" })
        }, 0)
      }
    } else {
      setOpenFamilies([])
    }
  }

  return (
    <ListButton
      icon={isOpen ? faChevronUp : faChevronDown}
      text={isOpen ? t("Fermer tout") : t("Ouvrir tout")}
      onClick={handleToggle}
      isInactive={riskFamilies.length === 0}
    />
  )
}
